/*
 * Copyright (c) 2022 Virginia Tech Transportation Institute.  All rights reserved.
 */

import React from 'react'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import { AnalyticsApp } from '../../common/models/analyticsApp'
import { Card, CardActions, CardHeader, Typography } from '@material-ui/core'
import ScenarioButton from './ScenarioButton'

type ScenarioAppProps = {
  name: string;
  scenarios: AnalyticsApp[];
  style?: CSSProperties;
}

const ScenarioAppCard = (props: ScenarioAppProps): JSX.Element => {
  const { name, scenarios } = props
  const buttons = [...scenarios].sort((a, b) => a.sortOrder - b.sortOrder)

  if (buttons.length === 0) {
    return <div />
  }

  const { iconUrl, description } = buttons[0]

  return (
    <Card raised style={{ width: "100%", height: 180 }}>
      <CardHeader
        avatar={<img src={iconUrl} alt={name} width={80} height={80} />}
        title={<Typography variant="h5">{name}</Typography>}
        subheader={description}
      />
      <CardActions>
        {buttons.map(s => <ScenarioButton key={s.id} id={s.id} name={s.name} />)}
      </CardActions>
    </Card>
  )
}

export default ScenarioAppCard
